export default {
  path: '/v5/team',
  name: 'V5_team',
  component: () => import('./TeamPage.vue'),
};
